<template>
    <div>
        <v-card flat>
            <v-card-text style="overflow-y: auto;">
                <div v-if="isMobilePort">
                    <div class="d-flex align-center justify-space-between">
                        <h3 class="mb-3">Filters</h3>
                        <v-btn icon @click="handleClose">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div v-else>
                    <h3 class="mb-3">Filters</h3>
                </div>
                <div class="my-5">
                    <v-btn
                        v-if="isMobilePort"
                        class="mb-2"
                        color="primary"
                        block
                        @click="applyFilters">
                        Apply
                    </v-btn>
                    <v-btn
                        outlined
                        @click="resetFilters"
                        block>
                        Reset Filters
                    </v-btn>
                    <v-divider class="my-5"></v-divider>
                </div>
                <h4 class="mb-2">Notes</h4>
                <v-autocomplete
                    v-model="activeFilters.tags"
                    label="Project Tag"
                    :items="filters.tags"
                    item-text="text"
                    item-value="value"
                    clearable
                    outlined
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-autocomplete
                    v-model="activeFilters.createdBy"
                    label="Created By"
                    :items="filters.createdBy"
                    clearable
                    outlined
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-select
                    v-model="activeFilters.visibility"
                    v-if="userProfileType === 'enterprise'"
                    label="Visibility"
                    :items="filters.visibility"
                    clearable
                    outlined
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-select
                    v-model="activeFilters.createdDate"
                    label="Date"
                    :items="filters.createdDate"
                    clearable
                    outlined
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-divider class="my-2"></v-divider>
                <h4 class="mb-2">Titles</h4>

                <v-autocomplete
                    v-model="activeFilters.titles"
                    label="Title"
                    :items="filters.titles"
                    clearable
                    outlined
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-autocomplete
                    v-model="activeFilters.categories"
                    label="Category"
                    :items="filters.categories"
                    clearable
                    outlined
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                />

                <v-autocomplete
                    v-model="activeFilters.years"
                    label="Year"
                    :items="filters.years"
                    clearable
                    outlined
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Mobile from "../../inc/mixins/mobile";
import { defaultFilters } from "./defaultFilters";

export default {
    name: "filters",
    mixins: [Mobile],
    data() {
        return {
            activeFilters : {...this.defaultFilters}
        }
    },
    props: {
        /**
         * @type {Filters}
         */
        filters: {
            type: Object,
            default: () => {}
        },
        userProfileType: {
            type: String,
            default: () => ''
        },
        defaultFilters: {
            type: Object,
            default: () => {}
        },
        applyInstantFilters: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        activeFilters: {
            deep: true,
            handler(newVal) {
                if (this.applyInstantFilters) {
                    this.$emit("apply-filters", newVal);
                }
            }
        },
        defaultFilters: {
            deep: true,
            handler(updatedFilters) {
                if (!_.isEqual(this.activeFilters, updatedFilters)) {
                    this.activeFilters = {...updatedFilters};
                }
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit("close");
        },
        applyFilters(){
            this.$emit("apply-filters", {...this.activeFilters});
            this.handleClose();
        },
        resetFilters() {
            this.activeFilters = defaultFilters();
            this.$emit("apply-filters", {...this.activeFilters});
        }
    }
}
</script>
